/*
 * File: product-list.component.ts                                             *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 12th January 2022 17:06:58                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:55:39                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Product } from '@nousmedis/cc-types';
import { ProductService } from '../../../services/product.service';
import { ApiService } from '../../../../api/services/api.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit, OnDestroy {


  subs = new Subscription();
  @Input() items: Product[] = [];
  layout: string = 'list';
  loading: boolean;


  constructor (private api: ApiService,
    private productService: ProductService) { }

  ngOnInit(): void {
    
  }

  // test(e: any) {
  //   
  //   
  // }

  ondrag() {
    
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onDrop(event:any){
    const idDroppedProduct = this.productService.getDroppedProductToList();
    this.productService.dropToListHandler.next(idDroppedProduct)
  }

}
